import React, { useState, useEffect, useCallback } from "react";

import Tabela from "../../tabelas/Tabela";
import InputAutoComplete from "../../Componets/InputAutoComplete";
import { ToastContainer, toast } from "react-toastify";
import ReadingBookConcept from "../../imagem/ReadingBookConcept.png";
import lupa from "../../imagem/lupa.svg";
import iconVisualizar from "../../imagem/iconVisualizar.svg";
import {
  buscarGeneros,
  buscarTopLivros,
  InfoLivroTelaInicial,
} from "../../services/api";

import faixa from "../../imagem/faixa.svg";
import "../funcionario/Livros.css";
import "./TelaInicial.css";
import ModalInfoLivro from "../../modais/ModalInfoLivro";

function TelaInicial() {
  const [topLivros, setTopLivros] = useState([]);
  const [dadosLivros, setDadosLivros] = useState([]);
  const [dadosFormatadosLivros, setDadosFormatadosLivros] = useState([]);
  const [generoOpcoes, setGeneroOpcoes] = useState([]);
  const [generoSelecionado, setGeneroSelecionado] = useState(null);
  const [valorBusca, setValorBusca] = useState("");
  const [qtdLivrosPag, setQtdLivrosPag] = useState(0);
  const [loadingPagina, setLoadingPagina] = useState(false);

  const [abrirModal, setAbrirModal] = useState(false);
  const [livroSelecionado, setLivroSelec] = useState("");

  const colunasLivros = [
    "titulo",
    "autor",
    "genero",
    "disponibilidade",
    "localizacao",
    "acoes",
  ];

  const estiloTabelaLivros = {
    height: "130%",
    width: "100%",
    margin: "0 auto",
    border: "1px solid var(--cor-cinzaMargin)",
    borderRadius: 2,
  };

  const acoes = [
    {
      texto: "Visualizar livro",
      icon: iconVisualizar,
      func: (e) => AbrirModalInfoLivros(e),
    },
  ];

  const carregarDadosLivros = useCallback(
    async (pagina = 1, limiteLivros = 10) => {
      try {
        setLoadingPagina(true);

        const objTelaInicial = {
          limite: limiteLivros,
          pagina: pagina,
          nome: valorBusca,
          idGenero: generoSelecionado?.id
        };

        const { data } = await InfoLivroTelaInicial(objTelaInicial);

        setDadosLivros(data.content);
        setQtdLivrosPag(data.totalPages || 0);
      } catch (error) {
        toast.error("Erro ao carregar livros");
      } finally {
        setLoadingPagina(false);
      }
    },
    [generoSelecionado, valorBusca]
  );

  const carregarGenero = useCallback(async () => {
    try {
      const { data } = await buscarGeneros();
      const objGeneros = data.map((e) => ({ ...e, label: e.nome }));
      setGeneroOpcoes(objGeneros);
    } catch (error) {
      toast.error("Erro ao carregar gêneros");
    }
  }, []);

  const formataDadosLivros = useCallback(() => {
  const objRetorno =[];
   dadosLivros?.map((c) => 
    objRetorno.push({
    id: c?.idLivro,
    titulo: c?.titulo,
    autor: c?.autor,
    anoPublicacao: c?.anoPublicacao,
    livrosDisponiveis: c?.livrosDisponiveis,
    sinopse: c?.sinopse,
    genero: c?.genero,
    nota: c?.mediaEstrelas,
    quantidadeAvaliacoes: c?.quantidadeAvaliacoes,
    disponibilidade: c?.quantidadeLivros,
    localizacao: c?.localizacaoPratileira,
    favoritado: c?.livroFavoritado,
  }));
  setDadosFormatadosLivros(objRetorno);
}, [dadosLivros]);

  const clickPaginacao = (_, value) => {
    carregarDadosLivros(value);
  };

  const carregarTopLivros = useCallback(async () => {
    try {
      const { data } = await buscarTopLivros();
      setTopLivros(data);
    } catch (error) {
      toast.error("Erro ao carregar o Top 5 de livros");
    }
  }, []);

  useEffect(() => {
    carregarGenero();
    carregarDadosLivros();
  }, [carregarGenero, carregarDadosLivros]);

  useEffect(() => {
    formataDadosLivros();
  }, [dadosLivros]);

  useEffect(() => {
    carregarDadosLivros();
  }, [generoSelecionado, carregarDadosLivros]);

  useEffect(() => {
    if (valorBusca === "") {
      carregarDadosLivros();
    }
  }, [valorBusca]);

  useEffect(() => {
    carregarTopLivros();
  }, [carregarTopLivros]);

  function openModalLivros() {
    setAbrirModal(true);
  }

  function AbrirModalInfoLivros(livro) {
    openModalLivros();
    setLivroSelec({
      sinopse: livro?.sinopse,
      titulo: livro?.titulo,
      nota: livro?.nota,
      quantidadeAvaliacoes: livro?.quantidadeAvaliacoes,
      data: livro?.anoPublicacao,
      livrosDisponiveis: livro?.livrosDisponiveis,
      genero: livro?.genero,
      mediaEstrelas: livro?.nota,
      avaliacao: livro?.quantidadeAvaliacoes,
      id: livro?.id,
      autor: livro?.autor,
      favorito: livro?.favoritado,
    });
  }

  return (
    <div className="scroll">
      <div>
        <ModalInfoLivro
          abrirModal={abrirModal}
          fecharModal={() => setAbrirModal(false)}
          sinopse={livroSelecionado.sinopse}
          livrosDisponiveis={livroSelecionado.livrosDisponiveis}
          genero={livroSelecionado.genero}
          data={livroSelecionado.data}
          nome={livroSelecionado.titulo}
          quantidadeAvaliacoes={livroSelecionado.avaliacao}
          avaliacao={livroSelecionado.mediaEstrelas}
          idLivro={livroSelecionado.id}
          favorito={livroSelecionado.favoritado}
          autor={livroSelecionado.autor}
          favorito={livroSelecionado.favorito}
        />

        <div className="container_livro">
          <div>
            <h1>Acervo</h1>
          </div>
          <ToastContainer />
          <img className="faixa" src={faixa} alt="faixa" />

          <div className="top-Cards">
            <div className="cards-container">
              {topLivros.length > 0 ? (
                topLivros.slice(0, 5).map((livro) => (
                  <div className="card" key={livro.id}>
                    <img
                      className="card-img"
                      src={ReadingBookConcept}
                      alt="Livro Aberto"
                    />
                    <h1 className="card-title">{livro.titulo}</h1>
                    <p className="autor">{livro.autor}</p>
                    <p className="genero">
                      {Array.isArray(livro.genero)
                        ? livro.genero[0]
                        : "Sem gênero"}
                    </p>
                    <p className="ano-publicacao">{livro.anoPublicacao}</p>

                    <button
                      className="card-link"
                      onClick={() => AbrirModalInfoLivros(livro)}
                    >
                      Visualizar mais{" "}
                      <img src={iconVisualizar} alt="ícone de olho aberto" />
                    </button>
                  </div>
                ))
              ) : (
                <p className="mensagem-sem-top">
                  Ainda não há livros avaliados :(
                </p>
              )}
            </div>
          </div>

          <div className="caixa_filtros">
            <div className="input_buscar">
              <input
                type="text"
                placeholder="Buscar livro"
                className="input_tabela"
                value={valorBusca}
                onChange={(e) => setValorBusca(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") carregarDadosLivros();
                }}
              />
              <button className="btn-Lupa" onClick={() => carregarDadosLivros()}>
                <img src={lupa} alt="lupa de pesquisa" />
              </button>
            </div>

            <div style={{ width: "20%" }}>
              <InputAutoComplete
                options={generoOpcoes}
                placeholder="Gênero"
                value={generoSelecionado}
                change={(e) => setGeneroSelecionado(e)}
                style={{
                  "& .MuiOutlinedInput-root": {
                    borderColor: "--cor-cinzaMargin",
                    borderRadius: "0.8em",
                    height: "3em",
                  },
                }}
              />
            </div>
          </div>

          <div className="caixa_tabela">
            {dadosFormatadosLivros.length === 0 ? (
              <span>Nenhum dado encontrado.</span>
            ) : (
              <Tabela
                dados={dadosFormatadosLivros}
                colunas={colunasLivros}
                estiloTabela={estiloTabelaLivros}
                qtdPaginas={qtdLivrosPag}
                clickPaginacao={clickPaginacao}
                acoes={acoes}
                carregandoPagina={loadingPagina}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TelaInicial;
